import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import { InventoryService } from '../../../services/inventory-service';
import { GroupedOrderItems } from '../../../components/orders-drawer/sections/grouped-order-items';
import { openProductDetailModal } from '../../../store/products/products.actions';

import { defineMessages } from 'react-intl';
import { OrderDrawerSection } from '../../../enums/order-drawer-section';

import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';

const sectionId = OrderDrawerSection['ordered-items'];
const messages = defineMessages({
  unShippedItems: {
    description: 'orderDrawer.orderedItems',
    defaultMessage: 'Items',
    id: 'ruuymk',
  },
});

const shouldInventoryShow = (state, fulfillmentPlanIds) => {
  if (!fulfillmentPlanIds || !fulfillmentPlanIds.length || fulfillmentPlanIds.length > 1) {
    return false;
  }

  const [fulfillmentPlanId] = fulfillmentPlanIds;
  return InventoryService.shouldItemInventoryInformationShow(state, fulfillmentPlanId);
};

const mapStatesToProps = (state, ownProps) => {
  const { fulfillmentPlanIds } = ownProps;

  const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds }) || [];
  const totalCount = fulfillmentPlans
    .filter((fp) => fp)
    .reduce((acc, fp) => {
      const itemsLength = Array.isArray(fp.items) ? fp.items.length : 0;
      return acc + itemsLength;
    }, 0);

  return {
    totalCount,
    sectionHeader: messages.unShippedItems,
    willInventoryShow: shouldInventoryShow(state, fulfillmentPlanIds),
    ...mapStateToOpen(state, sectionId),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openProductDetailModal: (productId) => dispatch(openProductDetailModal(productId)),
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

export const ItemsSectionContainer = connect(mapStatesToProps, mapDispatchToProps);

export const OrderedItems = ItemsSectionContainer(GroupedOrderItems);
